module.exports = __webpack_public_path__ + "media/images/games/clash-royale/trophy-b5a4b9b2eec9ccc2025cff2763765cc2.svg";